<template>
  <section class="hero2"></section>

  <!-- Popup placée en dehors du conteneur pour éviter tout conflit -->
  <transition name="fade">
    <div v-if="showPopup" class="popup-backdrop" @click.self="closePopup">
      <div class="popup-content">
        <p style="margin-bottom: 1rem;">Un e-mail a été envoyé à votre adresse pour le code de confirmation.</p>
        <button class="popup-button" @click="closePopup">OK</button>
      </div>
    </div>
  </transition>

  <div class="login-container oc-auth-forgot">
    <h2 style="font-family: 'gagalin'; color: #e74c3c; margin-bottom: 15px; font-size: clamp(1.5rem, 2vw, 2rem);">
      Réinitialisation de mot de passe ?
    </h2>
    <p v-if="isNative" class="oc-auth-forgot__sub">
      {{ resetCodeSent
        ? 'Saisissez le code reçu par e-mail, puis choisissez un nouveau mot de passe.'
        : 'Indiquez votre adresse e-mail : nous vous envoyons un code de vérification.' }}
    </p>
    <form class="reset-password-form" @submit.prevent="submit">
      <div class="input-group oc-field">
        <input v-model="email" type="email" class="oc-field__control" placeholder="Adresse e-mail" required />
      </div>

      <!-- Afficher ces champs uniquement si le code a été envoyé -->
      <div v-if="resetCodeSent" class="oc-auth-forgot__step">
        <div class="input-group oc-field">
          <input v-model="resetCode" type="text" class="oc-field__control" placeholder="Code de réinitialisation" required />
        </div>
        <div class="input-group oc-field">
          <input v-model="password" type="password" class="oc-field__control" placeholder="Nouveau mot de passe" required />
        </div>
        <div class="input-group oc-field">
          <input v-model="password2" type="password" class="oc-field__control" placeholder="Confirmer le mot de passe" required />
        </div>
      </div>

      <p v-if="errorMessage" class="error-message">{{ errorMessage }}</p>
      <button type="submit" class="btn reset-button oc-btn oc-btn--primary oc-btn--block">
        {{ resetCodeSent ? 'Changer de mot de passe' : 'Requête de réinitialisation' }}
      </button>
    </form>
    <div class="login-footer">
      <a href="/login" class="oc-btn oc-btn--ghost">Déjà un compte ? Se connecter</a>
    </div>
  </div>
</template>

<script>
import { ref } from 'vue';
import { useRouter } from 'vue-router';
import axios from 'axios';
import { isNative } from '@/api/base';


export default {
  setup() {
    const router = useRouter();
    const email = ref('');
    const resetCode = ref('');
    const password = ref('');
    const password2 = ref('');
    const resetCodeSent = ref(false);
    const errorMessage = ref('');
    const showPopup = ref(false);
    const id = ref(''); 

    const closePopup = () => {
      showPopup.value = false;
    };

    const submit = async () => {
      if (!resetCodeSent.value) {
        try {
          const formData = new FormData();
          formData.append('email', email.value);

          const response = await axios.post('https://www.ouicsport.fr/api/authentication/forgotten-password', formData);

          const data = typeof response.data === 'string'
            ? JSON.parse(response.data)
            : response.data;

          id.value = data.data.id;

          resetCodeSent.value = true;
          showPopup.value = true;
        } catch (error) {
          errorMessage.value = 'Impossible de demander le code. Veuillez réessayer.';
          console.error(error);
        }
      } else {
        if (password.value !== password2.value) {
          errorMessage.value = 'Les mots de passe ne correspondent pas.';
          return;
        }
        try {
          const formData = new FormData();
          formData.append('code', resetCode.value);
          formData.append('password', password.value);
          formData.append('password2', password2.value);
          formData.append('id', id.value);

          const response = await axios.post('https://www.ouicsport.fr/api/authentication/forgotten-password/reset', formData);
          
          typeof response.data === 'string'
            ? JSON.parse(response.data)
            : response.data;

          errorMessage.value = 'Mot de passe réinitialisé avec succès !';
          
          setTimeout(() => {
            router.push('/login');
          }, 1000);
        } catch (error) {
          errorMessage.value = error.response && error.response.data
            ? error.response.data.message
            : 'Échec de la réinitialisation. Veuillez réessayer.';
        }
      }
    };
    return {
      email,
      resetCode,
      password,
      password2,
      resetCodeSent,
      errorMessage,
      showPopup,
      closePopup,
      submit,
      isNative
    };
  }
};
</script>

<style scoped>
.popup-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.popup-content {
  background: white;
  padding: 2rem;
  border-radius: 12px;
  max-width: 400px;
  width: 90%;
  text-align: center;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.2);
}

.popup-button {
  background: linear-gradient(135deg, #e74c3c, #c0392b);
  border: none;
  color: white;
  padding: 0.6rem 1.2rem;
  font-size: 1rem;
  font-weight: bold;
  border-radius: 8px;
  cursor: pointer;
  transition: background 0.3s, transform 0.2s;
}

.popup-button:hover {
  background: linear-gradient(135deg, #c0392b, #e74c3c);
  transform: scale(1.05);
}

/* Transition fade pour la popup */
.fade-enter-active, .fade-leave-active {
  transition: opacity 0.3s;
}
.fade-enter-from, .fade-leave-to {
  opacity: 0;
}
</style>

<style>
/* ==================== NATIVE APP STYLES ====================
   Écran « mot de passe oublié » de l'app. Mêmes jetons et même gabarit que
   l'écran de connexion, pour que les quatre écrans d'authentification se
   ressemblent. Toutes les règles sont préfixées `body.is-native`.
   ============================================================ */

body.is-native .hero2 {
  display: none;
}

/* Carte blanche sur le fond chaud, bas largement dégagé pour le clavier. */
body.is-native .oc-auth-forgot {
  width: auto;
  max-width: none;
  box-sizing: border-box;
  margin: var(--oc-sp-5) var(--oc-sp-4) calc(var(--oc-sp-12) + var(--oc-safe-bottom));
  padding: var(--oc-sp-6) var(--oc-sp-5);
  background: var(--oc-surface);
  border: 0;
  border-radius: var(--oc-r-lg);
  box-shadow: var(--oc-e1);
  text-align: left;
}

/* Le style en ligne du gabarit web impose !important. */
body.is-native .oc-auth-forgot h2 {
  margin: 0 0 var(--oc-sp-2) !important;
  font-family: var(--oc-font-display) !important;
  font-size: var(--oc-text-title) !important;
  font-weight: 400;
  line-height: 1.2;
  letter-spacing: 0.4px;
  color: var(--oc-ink) !important;
  text-align: left;
}

/* Deux étapes se succèdent dans le même formulaire : la ligne d'aide dit
   laquelle est en cours. */
body.is-native .oc-auth-forgot__sub {
  margin: 0 0 var(--oc-sp-6);
  font-size: var(--oc-text-base);
  line-height: 1.45;
  color: var(--oc-ink-2);
}

body.is-native .oc-auth-forgot .reset-password-form {
  display: flex;
  flex-direction: column;
  gap: var(--oc-sp-4);
  width: 100%;
}

body.is-native .oc-auth-forgot__step {
  display: flex;
  flex-direction: column;
  gap: var(--oc-sp-4);
  width: 100%;
}

body.is-native .oc-auth-forgot .input-group {
  flex: none;
  width: 100%;
  margin: 0;
}

body.is-native .oc-auth-forgot .input-group input {
  box-sizing: border-box;
  width: 100%;
  min-height: var(--oc-tap);
  height: 50px;
  margin: 0;
  padding: 0 var(--oc-sp-4);
  font-family: var(--oc-font-text);
  /* 16px au minimum : en dessous, iOS zoome à la mise au point du champ. */
  font-size: var(--oc-text-base);
  color: var(--oc-ink);
  background: var(--oc-surface);
  border: 1px solid var(--oc-line-2);
  border-radius: var(--oc-r-md);
  -webkit-appearance: none;
  appearance: none;
  outline: none;
  transition: border-color var(--oc-fast) var(--oc-ease),
              box-shadow var(--oc-fast) var(--oc-ease);
}

body.is-native .oc-auth-forgot .input-group input::placeholder {
  color: var(--oc-ink-3);
}

body.is-native .oc-auth-forgot .input-group input:focus {
  border-color: var(--oc-brand);
  box-shadow: 0 0 0 3px var(--oc-brand-100);
}

/* Le `.btn` du site plafonne à 300px et passe en majuscules : on neutralise. */
body.is-native .oc-auth-forgot .btn {
  width: 100%;
  max-width: none;
  min-height: var(--oc-tap);
  height: 52px;
  margin: var(--oc-sp-1) 0 0;
  padding: 0 var(--oc-sp-5);
  font-family: var(--oc-font-text);
  font-size: var(--oc-text-base);
  font-weight: 700;
  letter-spacing: 0.2px;
  text-transform: none;
  color: var(--oc-brand-ink);
  background: var(--oc-brand);
  border: 0;
  border-radius: var(--oc-r-full);
  box-shadow: var(--oc-e1);
  cursor: pointer;
}

body.is-native .oc-auth-forgot .btn:active {
  background: var(--oc-brand-600);
}

body.is-native .oc-auth-forgot .login-footer {
  margin: var(--oc-sp-2) 0 0;
  font-size: var(--oc-text-base);
  text-align: center;
}

body.is-native .oc-auth-forgot .login-footer a {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-height: var(--oc-tap);
  margin: 0;
  padding: 0 var(--oc-sp-4);
  font-size: var(--oc-text-base);
  font-weight: 700;
  color: var(--oc-brand);
  text-decoration: none;
}

body.is-native .oc-auth-forgot .error-message {
  margin: 0;
  padding: var(--oc-sp-3) var(--oc-sp-4);
  font-size: var(--oc-text-sm);
  font-weight: 600;
  line-height: 1.4;
  color: var(--oc-danger);
  background: var(--oc-danger-bg);
  border-radius: var(--oc-r-md);
  text-align: left;
}

/* Confirmation d'envoi du code : une feuille centrée, aux mêmes rayons et
   ombres que le reste de l'app. */
body.is-native .popup-backdrop {
  padding: var(--oc-sp-4);
  background: rgba(26, 22, 20, 0.55);
}

body.is-native .popup-content {
  box-sizing: border-box;
  width: 100%;
  max-width: 360px;
  padding: var(--oc-sp-6) var(--oc-sp-5);
  font-size: var(--oc-text-base);
  line-height: 1.45;
  color: var(--oc-ink);
  background: var(--oc-surface);
  border-radius: var(--oc-r-lg);
  box-shadow: var(--oc-e3);
}

body.is-native .popup-content p {
  margin: 0 0 var(--oc-sp-5) !important;
}

body.is-native .popup-button {
  width: 100%;
  min-height: var(--oc-tap);
  height: 52px;
  padding: 0 var(--oc-sp-5);
  font-family: var(--oc-font-text);
  font-size: var(--oc-text-base);
  font-weight: 700;
  color: var(--oc-brand-ink);
  background: var(--oc-brand);
  border-radius: var(--oc-r-full);
  box-shadow: var(--oc-e1);
}

/* Le survol du site applique un dégradé et un agrandissement : dans une
   webview tactile, cet état reste collé après l'appui. */
body.is-native .popup-button:hover {
  background: var(--oc-brand);
  transform: none;
}

body.is-native .popup-button:active {
  background: var(--oc-brand-600);
  transform: none;
}
</style>

